<template>
  <b-form @submit.stop.prevent="handleSubmit">
    <b-row>
      <b-col>
        <b-alert
          :show="hasBaseServerErrors()"
          variant="danger"
          dismissible
        >
          <p
            class="mb-0"
            v-for="(error, index) in baseServerErrors"
            :key="index"
          >
            {{ error }}
          </p>
        </b-alert>
        <b-alert
          v-if="destructiveSubtitle"
          variant="danger"
          :dismissible="false"
          show
          class="mb-3"
        >
          <i class="fa fa-exclamation-triangle mr-2" />
          {{ destructiveSubtitle }}
        </b-alert>
      </b-col>
    </b-row>

    <template v-if="description && !destructiveSubtitle">
      <p
        class="text-muted mb-3"
      >
        {{ description }}
      </p>
    </template>

    <slot name="downloads" />

    <b-form-group
      :label="fieldLabels.file"
      label-for="import-file"
      class="mt-3"
    >
      <b-form-file
        v-model="$v.form.file.$model"
        name="import-file"
        :state="$v.form.file.$dirty ? !$v.form.file.$error : null"
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
      />
      <b-form-invalid-feedback
        v-if="$v.form.file.$dirty"
        class="import-file-feedback"
      >
        <span v-if="!$v.form.file.required">Please enter a file.</span>
        <span v-if="!$v.form.file.serverFailed">{{ serverErrors.file }}</span>
      </b-form-invalid-feedback>
    </b-form-group>

    <hr class="mt-4">

    <b-row>
      <b-col
        offset-lg="6"
        lg="3"
        order="2"
        order-lg="1"
      >
        <b-button
          variant="link-dark"
          block
          class="import-close-button"
          @click="$emit('on-cancel')"
        >
          Cancel
        </b-button>
      </b-col>
      <b-col
        lg="3"
        order="1"
        order-lg="2"
      >
        <b-button
          class="import-submit-button text-nowrap"
          block
          type="submit"
          variant="primary"
          :disabled="processing"
        >
          Start import
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import formMixin from '@/mixins/formMixin';

export default {
  name: 'ImportsForm',
  mixins: [formMixin],
  props: {
    file: File,
    /** Optional one-line description shown at the top of the form (e.g. "Create or update work orders.") */
    description: {
      type: String,
      default: '',
    },
    destructiveSubtitle: {
      type: String,
    },
  },
  data() {
    return {
      form: {
        file: this.file,
      },
      fieldLabels: {
        file: 'File',
      },
    };
  },
  validations: {
    form: {
      file: {
        required,
        serverFailed() {
          return !this.hasServerErrors('file');
        },
      },
    },
  },
};
</script>
